import lodashCompact from 'lodash/fp/compact';
import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA } from 'api/actionTypes';

export default async function getTenantScreeningCriteria(
  { state, apiClient },
  { listingId, managementCompanyName, partnerSlug, includePartner, reload },
) {
  typeCheck('listingId::Maybe PositiveNumber', listingId);
  typeCheck('managementCompanyName::Maybe NonEmptyString', managementCompanyName);
  typeCheck('partnerSlug::Maybe NonEmptyString', partnerSlug);
  typeCheck('includePartner::Maybe Boolean', includePartner);
  typeCheck('reload::Maybe Boolean', reload);

  const listingStatePath = ['tenantScreeningCriteria', 'byListingId', listingId];
  const companyStatePath = [
    'tenantScreeningCriteria',
    'byPartnerManagementCompany',
    managementCompanyName,
  ];
  const slugStatePath = ['tenantScreeningCriteria', 'byPartnerSlug', partnerSlug];

  if (!reload) {
    if (listingId && state.get(listingStatePath)) {
      return state.get(listingStatePath);
    }
    if (managementCompanyName && state.get(companyStatePath)) {
      return state.get(companyStatePath);
    }
    if (partnerSlug && state.get(slugStatePath)) {
      return state.get(slugStatePath);
    }
  }
  const tenantScreeningCriteria = await apiClient.postWithState({
    action: SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA,
    queryId: lodashCompact([listingId, managementCompanyName, partnerSlug]).join('-'),
    state: state,
    payload: {
      listingId,
      managementCompanyName,
      partnerSlug,
      includePartner,
    },
  });

  if (listingId) {
    state.set(listingStatePath, tenantScreeningCriteria);
  }
  if (managementCompanyName) {
    state.set(companyStatePath, tenantScreeningCriteria);
  }
  if (partnerSlug) {
    state.set(slugStatePath, tenantScreeningCriteria);
  }

  return tenantScreeningCriteria;
}
